import React from "react";
import Link from "gatsby-link";
import cx from "classnames";
import NewsletterSignUp from "./NewsletterSignUp";
import Icon from "../components/Icon";
import { checkMap } from "../util/helperFunctions";

// Footer is on all pages except the downtown map page
const Footer = ({ location }) => {
  const hideFooter = checkMap(location.pathname);
  return (
    <div className={cx({ "display-none": hideFooter })}>
      <NewsletterSignUp />
      <div className="footer bg-stone-light">
        <ul className="ma0 list tc flex-l justify-between">
          <li className="footer__link-container mb0 pointer">
            <Link
              to="/explore-downtown/"
              className="footer__link--top-level db h-4 blue ttu tl-l"
            >
              Explore <br className="dn db-l" />
              Downtown
            </Link>
            <ul className="ma0 list dn db-l">
              <li className="ma0">
                <Link
                  to="/explore-downtown/riverfront-canal-walk/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Riverfront Canal Walk
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/explore-downtown/restaurants/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Restaurants
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/explore-downtown/shopping/"
                  className="footer__link--sub-level grey2 tl a-subnav db "
                >
                  Shopping
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/explore-downtown/outdoors/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Outdoors
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/explore-downtown/arts-and-culture/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Arts &amp; Culture
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/explore-downtown/attractions/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Attractions
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/explore-downtown/parking-and-transportation/"
                  className="footer__link--sub-level grey2 tl a-subnav db "
                >
                  Parking &amp; Transportation
                </Link>
              </li>

            </ul>
          </li>
          <li className="footer__link-container mb0 pointer">
            <Link
              to="/live-downtown/"
              className="footer__link--top-level db h-4 green ttu pointer tl-l"
            >
              Live <br className="dn db-l" />
              Downtown
            </Link>
            <ul className="ma0 list dn db-l">
              <li className="ma0">
                <Link
                  to="/live-downtown/historic-neighborhoods/"
                  className="footer__link--sub-level grey2 a-subnav db ease-out tl"
                >
                  Historic Neighborhoods
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/live-downtown/residential-facts/"
                  className="footer__link--sub-level grey2 a-subnav db ease-out tl"
                >
                  Residential Facts &amp; Figures
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/live-downtown/places-to-live/"
                  className="footer__link--sub-level grey2 a-subnav db ease-out tl"
                >
                  Places to Live
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/live-downtown/living-essentials/"
                  className="footer__link--sub-level grey2 a-subnav db ease-out tl"
                >
                  Living Essentials
                </Link>
              </li>
            </ul>
          </li>
          <li className="footer__link-container mb0 pointer">
            <Link
              to="/work-downtown/"
              className="footer__link--top-level db h-4 brick ttu tl-l"
            >
              Work <br className="dn db-l" />
              Downtown
            </Link>
            <ul className="ma0 list dn db-l">
              <li className="ma0">
                <Link
                  to="/work-downtown/demographics/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Demographics &amp; Market Data
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/work-downtown/development/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Downtown Development
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/work-downtown/relocating/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Relocating
                </Link>
              </li>
            </ul>
          </li>
          <li className="footer__link-container mb0 pointer">
            <Link
              to="/our-events/"
              className="footer__link--top-level db h-5 h-4--l dark ttu tl-l"
            >
              Our <br className="dn db-l" />
              Events
            </Link>
            <ul className="ma0 list dn db-l">
              <li className="ma0">
                <Link
                  to="/our-events/friday-cheers/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Friday Cheers
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/our-events/dominion-energy-riverrock/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Dominion Energy Riverrock
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/our-events/2nd-street-festival/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  2nd Street Festival
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/our-events/richmond-folk-festival/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Richmond Folk Festival
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/our-events/camp-kanawha-halloween-cruises/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Eerie Canal Halloween Cruises
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/our-events/featured-events/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Featured Downtown Events
                </Link>
              </li>
            </ul>
          </li>
          <li className="footer__link-container mb0 pointer">
            <Link
              to="/our-services/"
              className="footer__link--top-level db h-5 h-4--l dark ttu tl-l"
            >
              Our <br className="dn db-l" />
              Services
            </Link>
            <ul className="ma0 list dn db-l">
              <li className="ma0">
                <Link
                  to="/our-services/riverfront-canal-cruises/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Riverfront Canal Cruises
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/our-services/browns-island-improvement-plan/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Brown's Island Improvement Project
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/our-services/downtown-marketing/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Downtown Marketing
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/our-services/clean-safe-green/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Clean, Safe &amp; Green
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/our-services/placemaking/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Placemaking
                </Link>
              </li>

              <li className="ma0">
                <Link
                  to="/our-services/browns-island-rentals/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Brown's Island Rentals
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/our-services/service-district/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Service District
                </Link>
              </li>
            </ul>
          </li>
          <li className="footer__link-container mb0 pointer">
            <Link
              to="/about-us/"
              className="footer__link--top-level last db h-5 h-4--l dark ttu tl-l"
            >
              About <br className="dn db-l" />
              Us
            </Link>
            <ul className="ma0 list dn db-l">
              <li className="ma0">
                <Link
                  to="/about-us/our-board/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Our Board
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/about-us/our-staff/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Our Staff
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/about-us/our-contributors/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Our Contributors
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/about-us/donate/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Donate
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/about-us/faq/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  FAQ
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/about-us/reports/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Reports, Publications &amp; Plans
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/about-us/about-venture-richmond/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  About Us
                </Link>
              </li>
              <li className="ma0">
                <Link
                  to="/about-us/contact-us/"
                  className="footer__link--sub-level grey2 tl a-subnav db ease-out"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </li>
        </ul>
        <div className="footer__info-wrapper flex-l justify-between flex-row-reverse">
          <div className="footer__social-container flex flex-column items-center flex-row-l">
            <p className="ttu h-6 grey2 nowrap mb1 mb0-l mr2-l m">Follow Us!</p>
            <div className="flex">
              <a
                target="_blank"
                href="https://www.instagram.com/venturerichmond/"
              >
                <Icon
                  path="icon-26-instagram"
                  height="22"
                  width="22"
                  className="social-icon flex items-center mr2"
                />
              </a>
              <a
                target="_blank"
                href="https://www.facebook.com/venture.richmond/"
              >
                <Icon
                  path="icon-26-facebook"
                  height="22"
                  width="22"
                  className="social-icon flex items-center mr2"
                />
              </a>
              <a target="_blank" href="https://twitter.com/VentureRVA">
                <Icon
                  path="icon-26-twitter"
                  height="22"
                  width=""
                  className="social-icon flex items-center"
                />
              </a>
            </div>
          </div>
          <div className="footer__copyright-container flex flex-column items-center flex-row-l w-100 items-end-l">
            <div className="flex">
              <Link to="/">
                <Icon
                  path="logo-footer-mobile"
                  className="flex-nl dn-l logo-footer-mobile items-center mb3"
                />
                <Icon
                  path="logo-footer-desktop"
                  className="dn flex-l logo-footer-desktop mr3"
                />
              </Link>
            </div>
            <p className="a-subnav grey2 ma0">
              ©2018 Venture Richmond. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js